var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.72546 5.81182C3.72546 4.55994 3.72546 3.934 3.9691 3.45584C4.1834 3.03525 4.52536 2.69329 4.94596 2.47898C5.42411 2.23535 6.05005 2.23535 7.30193 2.23535H10.5804C11.8322 2.23535 12.4582 2.23535 12.9363 2.47898C13.3569 2.69329 13.6989 3.03525 13.9132 3.45584C14.1568 3.934 14.1568 4.55994 14.1568 5.81182V15.6471L8.94115 12.6667L3.72546 15.6471V5.81182Z",
    stroke: "white",
    strokeWidth: 1.4902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkWhite);
export default __webpack_public_path__ + "static/media/bookmark-white.267d3f27289d8bf73ef417219a8a9ca2.svg";
export { ForwardRef as ReactComponent };